import React, { useRef } from "react";
import "../src/common/primary.css";
import "../src/common/grid.css";
import Header from "./components/header/header";
import BannerSection from "./components/bannerSection/bannerSection";
import SolutionSection from "./components/solutionSection/solutionSection";
import ROI from "./components/roiSection/roiSection";
import UseCasesSection from "./components/useCasesSection/useCasesSection";
import BenefitsSection from "./components/benefitsSection/benefitsSection";
import FAQ from "./components/faqSection/faq";
import CTASection from "./components/ctaSection/cta";
import FooterSection from "./components/footer/footer";
import FeatureSection from "./components/featuresSection/featureSection";
import Partners from "./components/PartnerSection/Partners";

function App() {
  const sectionRefs = {
    solution: useRef(null),
    feature: useRef(null),
    useCases: useRef(null),
    faq: useRef(null),
  };
  const scrollToSection = (sectionName) => {
    const sectionRef = sectionRefs[sectionName];
    if (sectionRef && sectionRef.current) {
      const offset = 120;
      const topPosition = sectionRef.current.offsetTop - offset;
      window.scrollTo({ top: topPosition, behavior: "smooth" });
    }
  };

  return (
    <div className="app">
      <Header scrollToSection={scrollToSection} />
      <BannerSection />
      <Partners />
      <div ref={sectionRefs.solution}>
        <SolutionSection />
      </div>
      <ROI />
      <div ref={sectionRefs.feature}>
        <FeatureSection />
      </div>
      <div ref={sectionRefs.useCases}>
        <UseCasesSection />
      </div>
      <BenefitsSection />
      <div ref={sectionRefs.faq}>
        <FAQ />
      </div>
      <CTASection />
      <FooterSection />
    </div>
  );
}

export default App;
